import React from "react"
import {Form, Box, Columns, Heading} from "react-bulma-components";

export const DepositSection = ({rental, onChange}) => {

  const paymentMethods = [
    {name: "", value: "blank"},
    {name: "Direct Debit", value: "direct_debit"},
    {name: "Card Payments", value: "card_payments"},
    {name: "BACS", value: "bacs"}
  ]

  const paymentIntervals = [
    {name: "", value: "blank"},
    {name: "Weekly", value: "weekly"},
    {name: "Two Weekly", value: "two_weekly"},
    {name: "Four Weekly", value: "four_weekly"},
    {name: "Monthly", value: "monthly"},
  ]

  return (
    <Box>
      <Heading>Deposit & Initial Payment</Heading>
      <Columns>
        <Columns.Column>
          <Form.Field className={"has-addons"}>
            <Form.Control>
              <Form.Label>Deposit</Form.Label>
              <Form.Input
                  type="number"
                  name="deposit"
                  onChange={onChange}
                  value={rental.deposit}
                  required
              />
            </Form.Control>
          </Form.Field>
        </Columns.Column>
        <Columns.Column>
        <Form.Field className={"has-addons"}>
          <Form.Control>
            <Form.Label>Deposit Taken</Form.Label>
            <Form.Input
                type="number"
                name="customer_deposit_paid_amount"
                onChange={onChange}
                value={rental.customer_deposit_paid_amount}
                required
            />
          </Form.Control>
        </Form.Field>
        </Columns.Column>
        <Columns.Column>
            <Form.Control>
              <Form.Field>
                <Form.Label>Deposit Paid Date</Form.Label>
                <Form.Input
                  type="date"
                  name="deposit_paid_date"
                  onChange={onChange}
                  value={rental.deposit_paid_date}
                  required
                />
              </Form.Field>
            </Form.Control>
          </Columns.Column>
      </Columns>
      <Columns>
        <Columns.Column>
          <Form.Field className={"has-addons"}>
            <Form.Control>
              <Form.Label>Initial Payment</Form.Label>
              <Form.Input
                  type="number"
                  name="initial_payment"
                  onChange={onChange}
                  value={rental.initial_payment}
                  required
              />
            </Form.Control>
          </Form.Field>
        </Columns.Column>
        <Columns.Column>
          <Form.Field className={"has-addons"}>
            <Form.Control>
              <Form.Label>Initial Payment Taken</Form.Label>
              <Form.Input
                  type="number"
                  name="customer_initial_payment_paid_amount"
                  onChange={onChange}
                  value={rental.customer_initial_payment_paid_amount}
                  required
              />
            </Form.Control>
          </Form.Field>
        </Columns.Column>
        <Columns.Column>
            <Form.Control>
              <Form.Field>
                <Form.Label>Initial Payment Paid Date</Form.Label>
                <Form.Input
                  type="date"
                  name="initial_payment_date"
                  onChange={onChange}
                  value={rental.initial_payment_date}
                  required
                />
              </Form.Field>
            </Form.Control>
          </Columns.Column>
      </Columns>
      <Columns>
        <Columns.Column>
          <Form.Label>Customer Payment Method</Form.Label>
          <Form.Select
            name={"payment_method"}
            value={rental.payment_method}
            onChange={onChange}
          >
            {paymentMethods.map(method => (
                <option key={method.value} value={method.value}>{method.name}</option>
            ))}
          </Form.Select>
        </Columns.Column>
        <Columns.Column>
          <Form.Label>Customer Payment Interval</Form.Label>
          <Form.Select
            name={"customer_payment_interval"}
            value={rental.customer_payment_interval}
            onChange={onChange}
          >
            {paymentIntervals.map(interval => (
                <option key={interval.value} value={interval.value}>{interval.name}</option>
            ))}
          </Form.Select>
        </Columns.Column>
      </Columns>
      <Columns>
        <Columns.Column>
          <Form.Label>Comments</Form.Label>
          <Form.Textarea
            name={"deposit_comments"}
            value={rental.deposit_comments}
            onChange={onChange}
          />
        </Columns.Column>
      </Columns>
    </Box>
  )
}